import { render } from "./ChatView.vue?vue&type=template&id=6c6ad0e3&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"

import "./ChatView.vue?vue&type=style&index=0&id=6c6ad0e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6ad0e3"]])

export default __exports__